import { TRACKER } from '~/constants';
import { tracker } from './tracker';

type VerifyType = 'select' | 'corp' | 'owner';

export const trackVerifyEntry = (type: VerifyType, user: { userId: string }, sceneKey = '') => {
    tracker(
        {
            select: TRACKER.AUTH_TYPE_SELECT,
            corp: TRACKER.AUTH_TYPE_CORP,
            owner: TRACKER.AUTH_TYPE_OWNER
        }[type],
        {
            p1: user.userId,
            p2: sceneKey
        }
    );
};

export const trackVerifyOperate = (event: string, user: { userId: string }) => {
    tracker(event, {
        p1: user.userId
    });
};
